import { createAction } from '@reduxjs/toolkit'

// tryGetMyScopes
export const getAll = createAction('get_my_scopes')
export const getAllSuccess = createAction<string[]>('get_my_scopes_success')
export const getAllFailed = createAction('get_my_scopes_failed')

// tryUpdateMyScopes
export const update = createAction('update_my_scopes')
export const updateSuccess = createAction<string[]>('update_my_scopes_success')
export const updateFailed = createAction('update_my_scopes_failed')
